import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { apiEndpoints } from '../Utils/ApiConfig';
import { getDefaultLayoutForRole, stripDisabledNavFromLayout } from '../Utils/sidebarCatalog';
import { SIDEBAR_LAYOUT_UPDATED_EVENT } from '../Utils/sidebarLayoutEvents';

export function useSidebarLayout(roleId) {
  const [layout, setLayout] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchLayout = useCallback(() => {
    setLoading(true);
    return axios
      .get(apiEndpoints.sidebar_layout_me, {
        withCredentials: true,
        params: { _t: Date.now() },
      })
      .then((res) => {
        const fromApi = res.data?.layout;
        const raw =
          Array.isArray(fromApi) && fromApi.length > 0
            ? fromApi
            : getDefaultLayoutForRole(roleId);
        // Respect saved layout as returned by API (no client re-inject patches).
        setLayout(stripDisabledNavFromLayout(raw));
      })
      .catch(() => {
        setLayout(getDefaultLayoutForRole(roleId));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [roleId]);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      try {
        const res = await axios.get(apiEndpoints.sidebar_layout_me, {
          withCredentials: true,
          params: { _t: Date.now() },
        });
        if (cancelled) return;
        const fromApi = res.data?.layout;
        const raw =
          Array.isArray(fromApi) && fromApi.length > 0
            ? fromApi
            : getDefaultLayoutForRole(roleId);
        setLayout(stripDisabledNavFromLayout(raw));
      } catch {
        if (!cancelled) setLayout(stripDisabledNavFromLayout(getDefaultLayoutForRole(roleId)));
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    const onUpdated = () => {
      if (!cancelled) fetchLayout();
    };
    window.addEventListener(SIDEBAR_LAYOUT_UPDATED_EVENT, onUpdated);
    return () => {
      cancelled = true;
      window.removeEventListener(SIDEBAR_LAYOUT_UPDATED_EVENT, onUpdated);
    };
  }, [roleId, fetchLayout]);

  return { layout, loading, refetch: fetchLayout };
}
